import { date, formatCreditCardNumber } from "@catchoftheday/utilities";
export var formatPaymentMethods = function formatPaymentMethods(_ref) {
  var paymentMethods = _ref.paymentMethods;
  return paymentMethods.map(function (paymentMethod) {
    var id = paymentMethod.id,
        token = paymentMethod.token,
        type = paymentMethod.type,
        description = paymentMethod.description,
        iconName = paymentMethod.iconName,
        _paymentMethod$cardMa = paymentMethod.cardMaskedNumber,
        cardMaskedNumber = _paymentMethod$cardMa === void 0 ? null : _paymentMethod$cardMa,
        cardExpiryMonth = paymentMethod.cardExpiryMonth,
        cardExpiryYear = paymentMethod.cardExpiryYear;
    return {
      id: id,
      token: token,
      type: type,
      name: description,
      icon: iconName,
      formattedLabel: "".concat(description, " ").concat(cardMaskedNumber ? formatCreditCardNumber(cardMaskedNumber) : ""),
      cardMaskedNumber: cardMaskedNumber,
      cardExpiry: cardExpiryYear && cardExpiryMonth ? date.format(new Date(cardExpiryYear, cardExpiryMonth), "MM/yy") : null
    };
  });
};